module.exports = __webpack_public_path__ + "static/media/21.56ffc958.mp3";